// removed by extract-text-webpack-plugin
module.exports = {"canvas":"series__canvas_23VJW","drawing":"series__drawing_Yzx2v","erasing":"series__erasing_1U7OS","root":"series__root_5wfcy","shown":"series__shown_-A0a1","showOverlay":"series__showOverlay_vfmCV","hide":"series__hide_3t8NP","hideOverlay":"series__hideOverlay_2-7o1","seriesComics":"series__seriesComics_Y92Lk","comicIssue":"series__comicIssue_1KBFY","closeOverlay":"series__closeOverlay_GVdYr","canvasWrapper":"series__canvasWrapper_2Fq03"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/series/styles.less
// module id = ./src/client/components/series/styles.less
// module chunks = comics